import {
  Backdrop,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  Divider,
  ExpansionPanel,
  ExpansionPanelDetails,
  ExpansionPanelSummary,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';

const useStyles = makeStyles(theme => ({
  root: {},
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  }
}));

function Bulten({ className, ReceiptNo, readonly, tasks }) {
  const classes = useStyles();
  const { t } = useTranslation('Work_Order');
  const [BultenData, setBultenData] = useState([]);
  const SessionUser = getUser();
  const BirimKodu = SessionUser.ServiceShopId;
  const TeknisyenKodu = SessionUser.TechnicianId;
  const [Loading, setLoading] = useState(true);
  const [expanded, setExpanded] = useState(false);
  const Data = tasks.tasks.filter(
    d => parseInt(d.ReceiptNo) === parseInt(ReceiptNo)
  );
  const Model = Data && Data[0] && Data[0].ModelCode;
  const [PdfUrl, setPdfUrl] = useState(null);

  useEffect(() => {
    let mounted = true;
    const fetchTodos = () => {
      let ModelParam = '-1';
      if (Model !== '') {
        ModelParam = Model;
      }
      axios
        .get(`/GetSiriusBulletin/1/${BirimKodu}/${TeknisyenKodu}/${ModelParam}`)
        .then(response => {
          if (mounted) {
            const Deger = response.data === '' ? [] : response.data;
            setBultenData(Deger);
            setLoading(false);
          }
        })
        .catch(error => {
          setLoading(false);
        });
    };
    fetchTodos();
    return () => {
      mounted = false;
    };
  }, [ReceiptNo, BirimKodu, TeknisyenKodu, Model]);

  const BultenDetayAc = log => {
    setLoading(true);
    const dataBultenDetay = {
      ServiceShopId: SessionUser.ServiceShopId,
      UserId: SessionUser.UserId,
      FilePtr: log.StreamId
    };
    const config = {
      responseType: 'blob',
      headers: { 'Content-Type': 'application/json' }
    };
    axios
      .post('/FileImportExport/SiriusBulletin', dataBultenDetay, config)
      .then(response => {
        // openBlob(response.data, log.BT + '_' + log.AY + '_' + log.BN);
        const fileURL = URL.createObjectURL(response.data);
        setPdfUrl(fileURL);
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
      });
  };

  const user = getUser();
  const user_types = user.TechnicianType.split(',');
  let klima_teknisyeni = false;
  user_types &&
    user_types.forEach(u => {
      if (parseInt(u) === 26) {
        klima_teknisyeni = true;
      }
    });
  if (klima_teknisyeni) {
    return (
      <Card>
        <CardHeader title={t('Yetki_Kontrolu')} />
        <Divider />
        <CardContent className={classes.contentB}>
          {t('Yetki_Kontrolu_Mesaji')}
        </CardContent>
      </Card>
    );
  }

  const handleChange = panel => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div>
      <Card className={clsx(classes.root, className)}>
        <Backdrop className={classes.backdrop} open={Loading}>
          <CircularProgress color="inherit" />
        </Backdrop>
        <CardHeader title={t('Kutuphane')} />
        <Divider />
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={3} lg={3}>
              {BultenData.map(log => (
                <ExpansionPanel
                  key={log.DocumentType}
                  expanded={expanded === log.DocumentTypeId}
                  onChange={handleChange(log.DocumentTypeId)}
                >
                  <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                  >
                    <Typography className={classes.secondaryHeading}>
                      {log.DocumentType} ({log.Documents.length})
                    </Typography>
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>
                    <TableContainer component={Paper}>
                      <Table
                        className={classes.table}
                        aria-label="simple table"
                      >
                        <TableBody>
                          {log.Documents.map(row => (
                            <TableRow key={row.DocumentId}>
                              <TableCell
                                component="th"
                                onClick={e => BultenDetayAc(row)}
                                scope="row"
                              >
                                {row.StreamName}
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </ExpansionPanelDetails>
                </ExpansionPanel>
              ))}
            </Grid>
            <Grid item xs={12} sm={9} lg={9}>
              <iframe
                width="100%"
                height="700"
                src={PdfUrl}
                style={{ border: 'none' }}
              />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </div>
  );
}

Bulten.propTypes = {
  className: PropTypes.string
};

export default connect(state => ({ tasks: state.tasks1 }))(Bulten);
